'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationCorrespondences', ['$scope', '$rootScope', 'Correspondences', function ($scope, $rootScope, Correspondences) {
        $scope.resetInvestigation();
        $scope.bulkActionItems = [];
        $scope.bulkActionRunning = false;

        $scope.downloadZIP = function (bulkActionItemIds, bulkApply) {
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;

            if (!bulkActionItemIds || bulkActionItemIds.length === 0 || bulkActionItemIds.length > 50) {
                $scope.bulkActionRunning = false;
                alert("Please select between 1 and 50 correspondences");
            }
            else {
                Correspondences.downloadZIP(bulkActionItemIds).then(function (data) {
                    data = "data:text/plain;base64," + data;
                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "download.zip";
                    link.click();

                    $scope.bulkActionRunning = false;
                });
            }
        }

        $scope.columns = [
            {
                label: 'Subject',
                field: 'subject',
                link: {
                    state: 'internal.licensing.investigation.correspondence',
                    params: [
                        {
                            name: 'investigationCorrespondenceID',
                            field: 'id'
                        },
                        {
                            name: 'investigation_correspondence',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Template',
                field: 'merge_template_name'
            },
            {
                label: 'Sent On',
                field: 'createdon',
                type: 'date',
                revertTimeZone: true
            },
            {
                label: 'Sent By',
                field: 'createdby'
            }
        ];

        $scope.filters = [
            {
                name: 'Template',
                field: 'merge_template_id',
                service: 'MergeTemplates',
                method: 'getInvestigationTemplates'
            },
            {
                name: 'Users',
                field: 'entered_by',
                options: [
                    { id: null, name: 'All Users' },
                    { id: $rootScope.userAccount.id, name: 'My Correspondence' }
                ],
                value: null,
                showBlank: false
            },
            {
                name: 'Date',
                field: 'createdon',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]
    }])
;